var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlavours(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 28,
    viewBox: "0 0 22 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 16.6667C6.88405 16.6667 7.7319 16.3155 8.35702 15.6904C8.98214 15.0653 9.33333 14.2174 9.33333 13.3334C9.33333 11.4934 8.66666 10.6667 8 9.33337C6.57066 6.47604 7.70133 3.92804 10.6667 1.33337C11.3333 4.66671 13.3333 7.86671 16 10C18.6667 12.1334 20 14.6667 20 17.3334C20 18.559 19.7586 19.7727 19.2895 20.9051C18.8205 22.0375 18.133 23.0664 17.2663 23.933C16.3996 24.7997 15.3707 25.4872 14.2384 25.9563C13.106 26.4253 11.8923 26.6667 10.6667 26.6667C9.44099 26.6667 8.22732 26.4253 7.09495 25.9563C5.96258 25.4872 4.93368 24.7997 4.067 23.933C3.20032 23.0664 2.51283 22.0375 2.04379 20.9051C1.57474 19.7727 1.33333 18.559 1.33333 17.3334C1.33333 15.796 1.91066 14.2747 2.66666 13.3334C2.66666 14.2174 3.01785 15.0653 3.64297 15.6904C4.26809 16.3155 5.11594 16.6667 6 16.6667Z",
    stroke: "white",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlavours);
export default __webpack_public_path__ + "static/media/flavours.be7d766395546e36601a41bc3a683a3e.svg";
export { ForwardRef as ReactComponent };